import {
  Box,
  Button,
  CircularProgress,
  TableCell,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import DataTable from "../../../../Components/DataTable/DataTable";
import { useParams } from "react-router-dom";
import { getRequestsAction } from "../../../../store/actions/requests/index";
import CategoriesSelect from "../Components/CategoriesSelect";
import ChangeCategoryModal from "./ChangeCategoryModal";

export default function Requests() {
  const { userId, projectId } = useParams();
  const dispatch = useDispatch();

  const [categories, setCategories] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, perPage: 10 });
  const [changeCategoryOpen, setChangeCategoryOpen] = useState(false);

  const openChangeCategory = useCallback(
    (request) => setChangeCategoryOpen({ request }),
    []
  );
  const closeChangeCategory = useCallback(
    () => setChangeCategoryOpen(false),
    []
  );

  const handleChangePage = (_, page) => {
    setPagination((prev) => ({ ...prev, page: page + 1 }));
  };

  const handleChangePerPage = (event) => {
    setPagination({ page: 1, perPage: +event.target.value });
  };

  const data = useSelector((s) => s?.requests?.data);
  const loading = useSelector((s) => s?.requests?.loading);
  const count = useSelector((s) => s?.requests?.count);

  const getRequests = useCallback(() => {
    getRequestsAction({
      page: pagination?.page,
      limit: pagination?.perPage,
      creatorId: userId,
      projectId,
      categories: categories?.map((e) => e?.id),
    })(dispatch);
  }, [dispatch, userId, pagination, projectId, categories]);

  useEffect(() => {
    getRequests && getRequests({});
  }, [getRequests]);

  return (
    <>
      {changeCategoryOpen && (
        <ChangeCategoryModal
          open={changeCategoryOpen}
          handleClose={closeChangeCategory}
          getRequests={getRequests}
        />
      )}
      {loading ? (
        <Box
          sx={{ display: "flex", justifyContent: "center", py: 3, width: 1 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            gap: "1em",
          }}
        >
          <Box sx={{ bgcolor: "#FAFAFA", p: "0.4em 1em" }}>
            <Typography variant="subtitle1" sx={{ color: "#081531" }}>
              Requests
            </Typography>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", p: "0.4em 1em" }}>
            <Typography fontWeight="bold" sx={{ mr: 1 }}>
              Total Requests:
            </Typography>
            <Typography>{count}</Typography>
          </Box>

          <CategoriesSelect
            title={"Categories"}
            placeHolder="Filter by categories"
            value={categories}
            onChange={(_, v) => setCategories(v)}
          />

          <Box sx={{ bgcolor: "#FFF", p: "1em" }}>
            <DataTable
              data={data?.resData?.map((request) => ({
                ...request,
                creator: request?.creator?.username,
                project: request?.project?.name,
                category: request.category?.name,
              }))}
              renderCustomCells={(row) => (
                <TableCell>
                  <Button
                    onClick={() => openChangeCategory(row)}
                    variant="contained"
                  >
                    Change Category
                  </Button>
                </TableCell>
              )}
              extraHeaders={["Change Category"]}
              handleChangePage={handleChangePage}
              handleChangePerPage={handleChangePerPage}
              perPage={pagination?.perPage}
              count={count}
              page={pagination?.page}
            />
          </Box>
        </Box>
      )}
    </>
  );
}
